import React from 'react';
import './Home.css';
import { FaShieldAlt, FaVideo, FaBolt, FaDesktop, FaLock } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import Services from '../../components/Services/Services';
import partnerLogo1 from '../../img/parceiros2.jpg';
import partnerLogo3 from '../../img/parc.png';

const additionalItems = [
  {
    title: 'Sistemas de Segurança Eletrónica',
    text: 'Implementação de soluções de segurança electrónica para proteção de pessoas, instalações e património — instalação, configuração, integração e manutenção.',
    icon: <FaShieldAlt />
  },
  {
    title: 'Montagem de Câmaras de Vigilância (CCTV)',
    text: 'Fornecimento, instalação e configuração de câmaras, DVR/NVR e equipamentos para monitorização eficiente e segura.',
    icon: <FaVideo />
  },
  {
    title: 'Montagem de Cercas Elétricas',
    text: 'Instalação e manutenção de cercas eléctricas para reforço da segurança perimetral e prevenção de intrusões.',
    icon: <FaBolt />
  },
  {
    title: 'Venda de Material Informático',
    text: 'Fornecimento de computadores, periféricos, equipamentos de rede e consumíveis para empresas e particulares.',
    icon: <FaDesktop />
  },
  {
    title: 'Venda de Material de Segurança Eletrónica',
    text: 'Fornecimento de câmaras, DVR/NVR, alarmes, sensores, cercas eléctricas e soluções de controlo de acesso.',
    icon: <FaLock />
  }
];

const Home = () => {
  return (
    <div className="home-page">
      <Hero />

      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Nossos Serviços</h2>
          <Services limit={6} />
        </div>
      </section>

      <section className="additional-services-section">
        <div className="container">
          <h2 className="section-title">Serviços Adicionais</h2>
          <div className="additional-services-grid">
            {additionalItems.map((it, idx) => (
              <article className="additional-card" key={idx}>
                <div className="additional-icon">{it.icon}</div>
                <h3 className="additional-title">{it.title}</h3>
                <p className="additional-text">{it.text}</p>
              </article>
            ))}
          </div>
          {/* <div className="infosfera-credit">INFOSFERA</div> */}
        </div>
      </section>

      <section className="partners-section">
        <div className="container">
          <div className="partners-card">
            <div className="partners-content">
              <h2 className="partners-title">Parceiros</h2>
              <p className="partners-desc">A Infosfera trabalha em parceria com organizações estratégicas para oferecer soluções integradas e de elevada qualidade.</p>
            </div>
            <div className="partners-logos">
              {[{src: partnerLogo1},  {src: partnerLogo3}].map((p, i) => (
                <figure className="partner-item" key={i}>
                  <img src={p.src} alt={p.name} className="partner-logo" />
                  <figcaption className="partner-name">{p.name}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;